import React, { useState, useMemo } from 'react';
import Calendar from '@cobalt/react-calendar';
import { useTheme } from '@cobalt/react-theme-provider';
import { defaultMonths, defaultWeekdays, getDefaultMonth, getDefaultYear, formatDaysForCalendar, MonthSelection, MonthYearNavigation } from '@cobalt-marketplace/datepicker-utils';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const DatePicker = ({
  availableYears = [],
  disabledDays = [],
  highlightToday = false,
  highlightedDays = [],
  month: initialMonth,
  months = defaultMonths,
  selectedDay,
  weekdays = defaultWeekdays,
  weekStart = "SUN",
  withNavigation,
  year: initialYear,
  ...props
}) => {
  const theme = useTheme();
  const [month, setMonth] = useState(getDefaultMonth(initialMonth, selectedDay));
  const [year, setYear] = useState(getDefaultYear(initialYear, selectedDay));
  const [isMonthSelection, setIsMonthSelection] = useState(false);
  const memoizedDisabledDays = useMemo(() => formatDaysForCalendar(disabledDays, month, year), [disabledDays, month, year]);
  const memoizedHighlightedDays = useMemo(() => {
    const currentDate = new Date();
    const dates = !highlightToday ? highlightedDays : [...highlightedDays, {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate()
    }];
    return formatDaysForCalendar(dates, month, year);
  }, [highlightToday, highlightedDays, month, year]);
  const memoizedSelectedDays = useMemo(() => formatDaysForCalendar(selectedDay ? [selectedDay] : [], month, year), [selectedDay, month, year]);

  const onMonthSelection = newMonth => {
    setMonth(newMonth);
    setIsMonthSelection(false);
  };

  return isMonthSelection ? /*#__PURE__*/React.createElement(MonthSelection, {
    months: months,
    onClickMonth: onMonthSelection,
    selectedMonth: month
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, withNavigation && !!availableYears.length && /*#__PURE__*/React.createElement(MonthYearNavigation, {
    availableYears: availableYears,
    month: month,
    months: months,
    onChangeMonth: setMonth,
    onChangeYear: setYear,
    onClickMonth: () => setIsMonthSelection(true),
    year: year
  }), /*#__PURE__*/React.createElement(Calendar, _extends({
    disabledDays: memoizedDisabledDays,
    highlightedDays: memoizedHighlightedDays,
    month: month,
    selectedDays: memoizedSelectedDays,
    style: {
      padding: theme.baseSpacing3
    },
    weekdays: weekdays,
    weekStart: weekStart,
    year: year
  }, props)));
};

export default DatePicker;
